// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAZbRaBPSk3O0qyQNOdNR8fJs-GUOWRO2I",
    authDomain: "e-store-dbdee.firebaseapp.com",
    databaseURL: "https://e-store-dbdee-default-rtdb.firebaseio.com",
    projectId: "e-store-dbdee",
    storageBucket: "e-store-dbdee.appspot.com",
    messagingSenderId: "273040049990",
    appId: "1:273040049990:web:510638b2764cef56544747",
    measurementId: "G-YWX4CK8SF9"
  };

export default firebaseConfig